import React          from 'react';
import Target         from './Target';
import ActionButton   from './ActionButton';
import colors         from '../../utils/colors';
import { makeStyles } from '@material-ui/core/styles';


const useStyles = makeStyles(theme => ({
    root: {
       position:       'fixed',
       left:           '50%',
       top:            '50%',
       transform:      'translate(-50%, -50%)',
       zIndex:         1,
       /* display:        'flex',
       flexFlow:       'column',
       alignItems:     'center',
       justifyContent: 'center', */
    },
    targetContainer: {
        display:    'flex',
        transition: 'opacity 0.3s',

    },
    messageContainer: {
      position:        'absolute',
      top:             0,
      left:            0,
      width:           '100%',
      height:          '100%',
      display:         'flex',
      alignItems:      'center',
      justifyContent:  'center',
      textAlign:       'center',
      flexFlow:        'column',
   },
   message: {
   /*  height:          80,
    width:           '100%', */
    display:         'flex',
    alignItems:      'center',
    justifyContent:  'center',
    textAlign:       'center',
    color:            colors.blue,
   },
   failure: {
      position:        'absolute',
      width:           '100%',
      bottom:          10,
      zIndex:          3,
      display:         'flex',
      alignItems:      'center',
      justifyContent:  'center',
      textAlign:       'center',
      color:           'red',
   },
   button: {
    height:          40,
    width:           140,
    fontSize:        20,
    marginLeft:      '50%',
    display:         'flex',
    alignItems:      'center',
    justifyContent:  'center',
    textAlign:       'center',
    borderRadius:    '0.5em',
    backgroundColor: colors.blue,
    color:           '#FFF',
    cursor:          'pointer',
    zIndex:          2,
     }
}));

type TargetContainerProps = {
    size:                  number[];
    correctValues:         number[];
    disabledEggsArr:       number[];
    testsArr:              number[];
    target_size:           number;
    target0Value:          number;
    target1Value:          number;
    selectableEggs:        number;
    selectedEggs:          number;
    transferedEggs:        number;
    maxSelections:         number;
    opacity:               number;
    draggedEgg:            number;
    failureCounter:        number;
    showFinalValue:        boolean;
    putEggBackInBox:       boolean;
    wideScreen:            boolean;
    stage1complete:        boolean;
    eraseImages:           boolean;
    closeAtTen:            boolean;
    success:               boolean;
    showError:             boolean;
    showActionButton:      boolean;
    showArrangementButton: boolean;
    dragOrSelect:          string;
    error:                 string;
    wrongAnswer:           string;
    tooSlow:               string;
    wrongMehubarim:        string;
    handleEggSelection:    (ind: number, counter: number, val: number) => void;
    handleMouseDown:       (e: React.MouseEvent, ind: number) => void;
    handleTouchStart:      (e: React.TouchEvent, ind: number) => void; 
    arrange:               () => void;
    submit:                () => void;
}

const TargetContainer: React.FC<TargetContainerProps> = ({ 
    size,
    testsArr,
    correctValues,
    disabledEggsArr,
    target_size, 
    selectableEggs,
    selectedEggs,
    transferedEggs,
    draggedEgg,
    showFinalValue,
    putEggBackInBox,
    maxSelections,
    target0Value,
    target1Value,
    wideScreen,
    dragOrSelect,
    opacity,
    stage1complete,
    closeAtTen,
    eraseImages,
    success,
    showError,
    error,
    wrongAnswer,
    tooSlow,
    wrongMehubarim,
    showActionButton,
    failureCounter,
    showArrangementButton,
    arrange,
    handleEggSelection,
    handleMouseDown,
    handleTouchStart,
    submit
}) => {

  const classes = useStyles();

  const disable = React.useMemo(() => {
   /*  console.log('maxSelections    :   ',maxSelections)
    console.log('selectedEggs     :   ',selectedEggs) */
    return maxSelections <= selectedEggs || maxSelections === 0 || !stage1complete || target0Value === 10 || target1Value === 10;
  },[maxSelections, selectedEggs, stage1complete, target0Value, target1Value])



  /*
  const disable = React.useMemo(() => {
    
   

    
    return (
        (maxSelections <= selectedEggs || !stage1complete)
        ||
        target0Value === 10
        ||
        target1Value === 10
        ||
        dragOrSelect === ''
      )
  },[maxSelections, selectedEggs, stage1complete, target0Value, target1Value, dragOrSelect])
*/

  const [width, height] = React.useMemo(() => {
    return[
      target_size * 2,
      target_size / 2
    ]
  },[target_size])


  return (
    <div 
        className = { classes.root }
        style = {{ 
          width:   width,
          height:  height,
        }}
    >
        <div 
          className = { classes.targetContainer }
          style = {{ 
            width:   width,
            height:  height,
            opacity: opacity
          }}
        >
          {
            [-1, -2].map((val, ind) => {
              return(
                <Target
                  key                = { `Target###${ ind }` }
                  index              = { val }
                  target_size        = { target_size }
                  value              = { !ind ? target0Value : target1Value }
                  wideScreen         = { wideScreen }
                  disable            = { disable || (selectableEggs !== ind && selectableEggs !== 2) }
                  selectable         = { selectableEggs === ind || selectableEggs === 2 }
                  dragOrSelect       = { dragOrSelect }
                  initialValue       = { correctValues[ind] }
                  putEggBackInBox    = { putEggBackInBox }
                  showFinalValue     = { showFinalValue }
                  draggedEgg         = { draggedEgg }        
                  disabledEggsArr    = { disabledEggsArr } 
                  eraseImages        = { eraseImages } 
                  closeAtTen         = { closeAtTen }
                  handleEggSelection = { handleEggSelection }
                  handleMouseDown    = { handleMouseDown }
                  handleTouchStart   = { handleTouchStart }
                />
              )
            })
          }
        </div>
        <div 
            className = { classes.button }
            onClick   = { arrange }
            style     = {{
              transform: `translate(-50%, ${ showArrangementButton ? 0 : -150 }vh)`
            }}
        >
            { `המשך` }
        </div>
        <ActionButton 
                testsArr         = { testsArr }
                success          = { success }
                showError        = { showError }
                error            = { error }
                wideScreen       = { wideScreen }
                wrongAnswer      = { wrongAnswer }
                tooSlow          = { tooSlow }
                wrongMehubarim   = { wrongMehubarim }
                stage1complete   = { stage1complete }
                showActionButton = { showActionButton && !showArrangementButton }
                failureCounter   = { failureCounter }
                submit           = { submit }
        />
    </div>
  )
}
export default TargetContainer
